import {
    Link
  } from "react-router-dom";

import { useDispatch } from 'react-redux'

import {Card, Typography, Box} from '@mui/material'

import useStyles from '../../../styles/global-mui.js'

//TODO UPDATE WITH REAL PICTOS SVGs
// ASK FOR MIX PICTO (MULTISPORT)
import picto_football from '../../../images/picto/sports/foot_picto.png'
import picto_rugby from '../../../images/picto/sports/rugby_picto.png'
import picto_basket from '../../../images/picto/sports/basket_picto.png'
import picto_handball from '../../../images/picto/sports/hand_picto.png'
import picto_mix from '../../../images/picto/standard/etoile.svg'

import { deleteLive } from '../../../actions/lives.js';
import LiveExport from '../../Live/LiveExport.js';
import { GET_LIVE_DETAILS } from '../../../constants/actionTypes.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan, faWifi } from '@fortawesome/free-solid-svg-icons';
import DsasButton from '../../../v1/components/DsasButton/DsasButton.js';
import { confirmActionNotification } from '../../../actions/notifications.js';
import { useNotifications } from '../../../v2/notifications/NotificationManager.js';
import { Can } from '../../../permissions/Can.js';
import { PERMISSIONS } from '../../../permissions/permissionKeys.js';

/**
 * (Sport) Live component to display a live match Card
 * @param {object} live - live object to display
 * @param {function} setCurrentId - function to set the current id of the live
 * @param {function} reload - function to reload the page
 * @return {JSX.Element} - Live component as Card
 * */
const Live = ({ live, setCurrentId, reload }) => {
    const classes = useStyles();

    const dispatch = useDispatch()

    const {addNotification} = useNotifications()

    const getPicto = () => {
        switch(live.discipline){
            case 'soccer':
                return picto_football
            case 'rugby':
                return picto_rugby
            case 'basket':
                return picto_basket
            case 'handball':
                return picto_handball
            case 'mix':
                return picto_mix
            default :
                return undefined
        }
    }

    const getTitle = () => {
        switch(live.discipline){
            case 'soccer':
                return 'Football';
            case 'rugby':
                return 'Rugby';
            case 'basket':
                return 'Basket';
            case 'handball':
                return 'Handball';
            case 'mix':
                return 'Multisport';
            default :
                return undefined
        }
    }

    const getSportClassName = () => {
        switch(live.discipline){
            case 'soccer':
                return 'football-title';
            case 'rugby':
                return 'rugby-title';
            case 'basket':
                return 'basket-title';
            case 'handball':
                return 'handball-title';
            case 'mix':
                return 'multisport-title';
            default :
                return 'other-title'; // fallback
        }
    }

    const getBtnClassName = () => {
        switch(live.discipline){
            case 'soccer':
                return 'blue'
            case 'rugby':
                return 'green'
            case 'basket':
                return 'orange'
            case 'handball':
                return 'green-alt'
            case 'mix':
                return 'purple'
            default :
                return undefined
        }
    }


    //'var(--color-blue-primary)'

    return (
        <Card className={classes.customCardVariant}>

            {/* <CardMedia className={classes.media} image={getImage()} title={"Live"}/> */}
            {/**Card header */}
            <Box className='live-card padding-wrapper cardHeaderFlex'>
                <Box className={`live-title centered-wrapper ${getSportClassName()}`}>
                
                    <Box><i>Direct</i></Box> 
                    <Box sx={{paddingLeft:'5px'}}><b>{getTitle()}</b></Box>
                    <Box sx={{paddingLeft:'5px'}}>
                        <FontAwesomeIcon
                        icon={faWifi} 
                        style={{ fontSize:'medium', rotate: '90deg' }} 
                    />
                    </Box>
                    
                </Box>
                <img className='picto' src={getPicto()} alt={live.discipline}/>
            </Box>


            <Box className='large-separator'></Box>

            
            <Box className='large-padding-left large-padding-right padding-wrapper column-wrapper' sx={{minHeight:'73px'}}>
                <Typography className='cardSubtitle'>
                    {new Date(live.dateTime).toLocaleString('fr-FR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false, // 24h
                })}
                </Typography>
                <Typography className='cardTitle'>
                    {live.name}
                </Typography>

            </Box>

            {/**Card content */}
            <Box sx={{minHeight:'328px', display: 'inline-grid', alignContent: 'space-around'}}>
                {/*NEW INTERFACE*/}
                <Box className='large-separator'></Box>
                <Box className='centered-column-wrapper padding-wrapper'>
                    <Typography className='cardSubtitle' sx={{marginBottom:'0', paddingBottom:'0', fontSize:'small'}}><i>Nouvelle interface</i></Typography>
                    <Link
                        to={`/sports/lives/${live._id}/calendar`}
                        rel="noopener noreferrer"
                    >
                    <DsasButton
                        label={`Accéder au direct`}
                        customColorClassname={getBtnClassName()}
                        variant="flat"
                    />
                    </Link>
                    {live.matchs.length > 1 && <Link  
                        to={`/sports/lives/${live._id}/day`}
                        rel="noopener noreferrer"
                    >
                        <DsasButton
                        label={`Direct par compétition`}
                        customColorClassname={getBtnClassName()}
                        variant="flat"
                    />
                    </Link>}
                </Box>
                <Box className='large-separator'></Box>

                <Box className='centered-column-wrapper padding-wrapper'>
                    <Typography className='cardSubtitle' sx={{marginBottom:'0', paddingBottom:'0', fontSize:'small'}}><i>Ancienne interface</i></Typography>
                <Link
                    to={`/lives/${live._id}`}
                    style={{ textDecoration: 'none'}}
                    rel="noopener noreferrer"
                    onClick={() => dispatch({ type: GET_LIVE_DETAILS, payload: undefined })}
                    >
                    <DsasButton
                        label={`Accéder au direct`}
                        customColorClassname={getBtnClassName()}
                        variant="flat"
                    />
                    </Link>

                    {live.matchs.length > 1 && <Link
                    to={`/livecompetition/${live._id}`}
                    style={{ textDecoration: 'none'}}
                    rel="noopener noreferrer"
                    onClick={() => dispatch({ type: GET_LIVE_DETAILS, payload: undefined})}
                    >
                    <DsasButton
                        label={`Direct par compétition`}
                        customColorClassname={getBtnClassName()}
                        variant="flat"
                    />
                    </Link>}
                </Box>
            </Box>
            <Box className='large-separator'></Box>

            {/**Card footer / Actions */}
            <Box className='cardActions'>
                <Box className='centered-column-wrapper'>
                    <Can  permission={PERMISSIONS.SPORT_LIVES_HOME_BUTTON_EDIT}>
                        <DsasButton 
                        customCss={{ margin: '10px'}} 
                        label='Éditer' 
                        icon={faPenToSquare} 
                        onClick={() => {setCurrentId(live._id)}} 
                        variant = 'secondary'
                        customClassname='smaller'
                        />
                    </Can>
                </Box>
                
                <Box className='large-vertical-separator'></Box>

                <Box className='centered-column-wrapper'>
                    <Can  permission={PERMISSIONS.SPORT_LIVES_HOME_BUTTON_DELETE}>
                    <DsasButton 
                    customCss={{ margin: '10px'}} 
                    label='Supprimer' 
                    icon={faTrashCan} 
                    onClick={() => { dispatch(confirmActionNotification("Êtes-vous sûr de vouloir supprimer le direct ?", () => {
                                  dispatch(deleteLive(live._id, (id) => {reload() ; addNotification({
                                    title : "Suppression", 
                                    type : "success", 
                                    description : "Le live "+ live.name+" a été supprimé."
                                  })}))
                                })) }}
                    variant = 'secondary'
                    customClassname='smaller'
                    />
                    </Can>
                </Box>

                <Box className='large-vertical-separator'></Box>
                
                            <Box sx={{
                              display: 'grid',
                              margin:0
                            }}>
                              
                              {/*Export button*/}
                              <LiveExport idLive={live._id}/>
                            </Box>
            </Box>
        </Card>
        )
    
}

export default Live